import { useContext } from 'react'
import { RequestContext } from '../Contexts/RequestContext'
import { useAuth } from '@nic/kc-auth'
import { getUserDarwinRole } from '../User/utils'

/**
 * hook usato per determinare le associazioni delle richieste tra registry e registrar
 *
 */
export function useAssignmentRequest() {
  const { keycloak } = useAuth()
  const { stateReqById } = useContext(RequestContext)
  let userDarwinRole = getUserDarwinRole(keycloak)

  /** REGISTRAR **/
  const isRegistrarAssignedUser =
    keycloak?.tokenParsed?.userId === stateReqById?.data?.registrarUser?.id
  const isRegistrarAssigned = !!stateReqById?.data?.registrarUser?.id

  /** REGISTRY **/
  const isRegistryAssignedUser =
    keycloak?.tokenParsed?.userId === stateReqById?.data?.registryUser?.id
  const isRegistryAssigned = stateReqById?.data?.registryUser?.id !== undefined

  const registrarStatus: 'assignedTo' | 'assignedToMe' | undefined = isRegistrarAssignedUser
    ? 'assignedToMe'
    : isRegistrarAssigned
      ? 'assignedTo'
      : undefined

  const registryStatus: 'assignedTo' | 'assignedToMe' | undefined = isRegistryAssignedUser
    ? 'assignedToMe'
    : isRegistrarAssigned
      ? 'assignedTo'
      : undefined

  return {
    /** ruolo dell'utente (domain|admin|darwin|darwin-admin)**/
    userRole: userDarwinRole,
    /** la richiesta è già stata assegnata ad un utente Registrar **/
    isRegistrarAssigned,
    /** la richiesta è già stata assegnata ad un utente Registrar e quello attuale coincide **/
    isRegistrarAssignedUser,
    /** stato dell'operatore registrar **/
    registrarStatus,
    /** la richiesta è assegnata ad un utente Registry **/
    isRegistryAssigned,
    /** la richiesta è assegnata ad un utente Registry e quello attuale coincide **/
    isRegistryAssignedUser,
    /** stato dell'operatore registry **/
    registryStatus
  }
}
